import { SelfAssessmentJudgement } from './SelefassessmentJudgement';
import { SelfAssessmentT3ApproachDto } from './SelfAssessmentApproach';
import { SelfAssessmentInterpretation } from './SelfAssessmentInterpretation';
import { overallAssessmentDto } from './overall-aseesment';

export class interpretationAssessmentDto {
  id: number;
  summaryDetailsId: number;
  referenceNumber: number;
  title: string;
  topic: string;
  implementationDate: Date;
  implementationStatus: string;
  lbgMateriality: string;
  rfbMateriality: string;
  lbcmMateriality: string;
  submitterName: string;
  estimatedImpactLBG: string;
  estimatedImpactRFB: string;
  estimatedImpactLBCM: string;
  interpretationDetails: string;
  implementationComments: string;
  muteInterpretationDetailsUsers: string;
  muteImplementationCommentsUsers: string;
  readyForReview: boolean;
  constructor(data: SelfAssessmentInterpretation) {
    this.id = data.id;
    this.summaryDetailsId = data.summaryDetailsId;
    this.referenceNumber = data.referenceNumber;
    this.title = data.title;
    this.topic = data.topic;
    this.implementationDate = data.implementationDate;
    this.implementationStatus = data.implementationStatus;
    this.lbgMateriality = data.lbgMateriality;
    this.rfbMateriality = data.rfbMateriality;
    this.lbcmMateriality = data.lbcmMateriality;
    this.submitterName = data.submitterName;
    this.estimatedImpactLBG = data.estimatedImpactLBG;
    this.estimatedImpactRFB = data.estimatedImpactRFB;
    this.estimatedImpactLBCM = data.estimatedImpactLBCM;
    this.interpretationDetails = data.interpretationDetails;
    this.implementationComments = data.implementationComments;
    this.muteInterpretationDetailsUsers = data.muteInterpretationDetailsUsers;
    this.muteImplementationCommentsUsers = data.muteImplementationCommentsUsers;
    this.readyForReview = data.readyForReview;
  }
}
export class judgementAssessmentDto {
  id: number;
  summaryDetailsId: number;
  referenceNumber: string;
  title: string;
  topic: string;
  implementationDate: Date;
  implementationStatus: string;
  lbgMateriality: string;
  rfbMateriality: string;
  lbcmMateriality: string;
  submitterName: string;
  estimatedImpactLBG: string;
  estimatedImpactRFB: string;
  estimatedImpactLBCM: string;
  judgementDetails: string;
  judgementImplementationComments: string;
  muteJudgementDetailsUsers: string;
  muteJudgementImplementationCommentsUsers: string;
  readyForReview: boolean;
  constructor(data: SelfAssessmentJudgement) {
    this.id = data.id;
    this.summaryDetailsId = data.summaryDetailsId;
    this.referenceNumber = data.referenceNumber;
    this.title = data.title;
    this.topic = data.topic;
    this.implementationDate = data.implementationDate;
    this.implementationStatus = data.implementationStatus;
    this.lbgMateriality = data.lbgMateriality;
    this.rfbMateriality = data.rfbMateriality;
    this.lbcmMateriality = data.lbcmMateriality;
    this.submitterName = data.submitterName;
    this.estimatedImpactLBG = data.estimatedImpactLBG;
    this.estimatedImpactRFB = data.estimatedImpactRFB;
    this.estimatedImpactLBCM = data.estimatedImpactLBCM;
    this.judgementDetails = data.judgementDetails;
    this.judgementImplementationComments = data.judgementImplementationComments;
    this.muteJudgementDetailsUsers = data.muteJudgementDetailsUsers;
    this.muteJudgementImplementationCommentsUsers =
      data.muteJudgementImplementationCommentsUsers;
    this.readyForReview = data.readyForReview;
  }
}
export class ApproachAssessmentDto {
  id: number;
  summaryDetailsId: number;
  referenceNumber: string;
  title: string;
  topic: string;
  implementationDate: Date;
  implementationStatus: string;
  lbgMateriality: string;
  rfbMateriality: string;
  lbcmMateriality: string;
  submitterName: string;
  estimatedImpactLBG: string;
  estimatedImpactRFB: string;
  estimatedImpactLBCM: string;
  approachDetails: string;
  approachImplementationComments: string;
  muteApproachDetailsUsers: string;
  muteApproachImplementationCommentsUsers: string;
  readyForReview: boolean;
  constructor(data: SelfAssessmentT3ApproachDto) {
    this.id = data.id;
    this.summaryDetailsId = data.summaryDetailsId;
    this.referenceNumber = data.referenceNumber;
    this.title = data.title;
    this.topic = data.topic;
    this.implementationDate = data.implementationDate;
    this.implementationStatus = data.implementationStatus;
    this.lbgMateriality = data.lbgMateriality;
    this.rfbMateriality = data.rfbMateriality;
    this.lbcmMateriality = data.lbcmMateriality;
    this.submitterName = data.submitterName;
    this.estimatedImpactLBG = data.estimatedImpactLBG;
    this.estimatedImpactRFB = data.estimatedImpactRFB;
    this.estimatedImpactLBCM = data.estimatedImpactLBCM;
    this.approachDetails = data.approachDetails;
    this.approachImplementationComments = data.approachImplementationComments;
    this.muteApproachDetailsUsers = data.muteApproachDetailsUsers;
    this.muteApproachImplementationCommentsUsers =
      data.muteApproachImplementationCommentsUsers;
    this.readyForReview = data.readyForReview;
  }
}
export class reviewAssessmentData {
  id: number;
  summaryDetailsId: number;
  reviewDate: Date;
  reviewerName: string;
  natureOfReview: string;
  reviewStatus: string;
  reviewOutcome: string;
  reviewerComments: string;
  muteReviewerCommentsUsers: string;
  readyForApproval: boolean;
  constructor(
    data:
      | SelfAssessmentInterpretation
      | SelfAssessmentJudgement
      | SelfAssessmentT3ApproachDto
  ) {
    this.id = data.id;
    this.summaryDetailsId = data.summaryDetailsId;
    this.reviewDate = data.reviewDate;
    this.reviewerName = data.reviewerName;
    this.natureOfReview = data.natureOfReview;
    this.reviewStatus = data.reviewStatus;
    this.reviewOutcome = data.reviewOutcome;
    this.reviewerComments = data.reviewerComments;
    this.muteReviewerCommentsUsers = data.muteReviewerCommentsUsers;
    this.readyForApproval = data.readyForApproval;
  }
}
export class approvalsAssessmentData {
  id: number;
  summaryDetailsId: number;
  approvers: string;
  approverDate: Date;
  nextApprovalDue: Date;
  confirmApproval: string;
  approvalStatus: string;
  approverComments: string;
  muteApproverCommentsUsers: string;
  conditionalApproval: boolean;
  constructor(
    data:
      | SelfAssessmentInterpretation
      | SelfAssessmentJudgement
      | SelfAssessmentT3ApproachDto
  ) {
    this.id = data.id;
    this.summaryDetailsId = data.summaryDetailsId;
    this.approvers = data.approvers;
    this.approverDate = data.approverDate;
    this.nextApprovalDue = data.nextApprovalDue;
    this.confirmApproval = data.confirmApproval;
    this.approvalStatus = data.approvalStatus;
    this.approverComments = data.approverComments;
    this.muteApproverCommentsUsers = data.muteApproverCommentsUsers;
    this.conditionalApproval = data.conditionalApproval;
  }
}
export class conditionalApprovalAssessmentData {
  id: number;
  summaryDetailsId: number;
  actionType: string;
  actionOwner: string;
  actionDueDate: Date;
  actionClosed: Date;
  actionDetails: string;
  actionClosure: string;
  muteActionDetailsUsers: string;
  muteActionClosureUsers: string;
  constructor(
    data:
      | SelfAssessmentInterpretation
      | SelfAssessmentJudgement
      | SelfAssessmentT3ApproachDto
  ) {
    this.id = data.id;
    this.summaryDetailsId = data.summaryDetailsId;
    this.actionType = data.actionType;
    this.actionOwner = data.actionOwner;
    this.actionDueDate = data.actionDueDate;
    this.actionClosed = data.actionClosed;
    this.actionDetails = data.actionDetails;
    this.actionClosure = data.actionClosure;
    this.muteActionDetailsUsers = data.muteActionDetailsUsers;
    this.muteActionClosureUsers = data.muteActionClosureUsers;
  }
}
export class overAllAssessmentSaveData {
  id: number;
  assessorName: string;
  assessmentCategory: string;
  assessmentStatus: string;
  assessmentDate: Date;
  nextAssessmentDueDate: Date;
  assessorTeam: string;
  impactBusinessArea: string;
  lbgImpact: boolean | null = null;
  rfbImpact: boolean | null = null;
  lbcmImpact: boolean | null = null;
  complianceStatus: string;
  isActionRequired: boolean;
  assessmentFindings: string;
  muteAssessmentFindingsUsers: string;
  summaryDetailsId: number;
  constructor(data: overallAssessmentDto) {
    this.id = data.id;
    this.assessorName = data.assessorName;
    this.assessmentCategory = data.assessmentCategory;
    this.assessmentStatus = data.assessmentStatus;
    this.assessmentDate = data.assessmentDate;
    this.nextAssessmentDueDate = data.nextAssessmentDueDate;
    this.assessorTeam = data.assessorTeam;
    this.impactBusinessArea = data.impactBusinessArea;
    this.lbgImpact = data.lbgImpact;
    this.rfbImpact = data.rfbImpact;
    this.lbcmImpact = data.lbcmImpact;
    this.complianceStatus = data.complianceStatus;
    this.isActionRequired = data.isActionRequired;
    this.assessmentFindings = data.assessmentFindings;
    this.muteAssessmentFindingsUsers = data.muteAssessmentFindingsUsers;
    this.summaryDetailsId = data.summaryDetailsId
  }
}
export class overAllReviewSaveData {
  id: number;
  summaryDetailsId: number;
  reviewDate: Date;
  reviewerName: string;
  reviewStatus: string;
  isActionRequired: boolean;
  reviewerComments: string;
  muteReviewCommentsUsers: string;
  constructor(data: overallAssessmentDto) {
    this.id = data.id;
    this.reviewDate = data.reviewDate;
    this.reviewerName = data.reviewerName;
    this.reviewStatus = data.reviewStatus;
    this.isActionRequired = data.isActionRequired;
    this.reviewerComments = data.reviewerComments;
    this.muteReviewCommentsUsers = data.muteReviewCommentsUsers;
    this.summaryDetailsId = data.summaryDetailsId;
  }
}
export class overAllApprovalSaveData {
  id: number;
  summaryDetailsId: number;
  actionType: string;
  actionOwner: string;
  actionDueDate: Date;
  actionClosed: Date;
  actionDetails: string;
  muteActionDetailsUsers: string;
  actionClosureSupportingRationale: string;
  muteActionClosureUsers: string;
  constructor(data: overallAssessmentDto) {
    this.id = data.id;
    this.actionType = data.actionType;
    this.actionOwner = data.actionOwner;
    this.actionDueDate = data.actionDueDate;
    this.actionClosed = data.actionClosed;
    this.actionDetails = data.actionDetails;
    this.muteActionDetailsUsers = data.muteActionDetailsUsers;
    this.actionClosureSupportingRationale = data.actionClosureSupportingRationale;
    this.muteActionClosureUsers = data.muteActionClosureUsers;
    this.summaryDetailsId = data.summaryDetailsId;
  }
}
